// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from './firebase'
import VueFire from 'vuefire'
import VueModal from 'vue-js-modal'
import Moment from 'vue-moment'
import 'moment/locale/de'

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(VueModal)
Vue.use(Moment)

firebase.app.auth().onAuthStateChanged(function (user) {
  if (user) {
    firebase.db.ref('/users/' + user.uid).once('value').then(function (snapshot) {
      const meta = snapshot.val()

      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        template: '<App/>',
        components: { App },
        router,
        data: {
          user: {
            uid: user.uid,
            email: user.email,
            name: meta.name,
            photo: meta.photo
          },
          firebase: firebase,
          admin: meta.admin,
          agent: meta.agent
        }
      })
    })
  } else {
     /* eslint-disable no-new */
    new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router,
      data: {
        user: null,
        firebase: firebase,
        admin: false
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js